import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAdbwbunZZmFUKFYUzmpQZntjk_Rj1syCQ",
  authDomain: "easytel-259d3.firebaseapp.com",
  databaseURL: "https://easytel-259d3.firebaseio.com/",
  projectId: "easytel-259d3",
  storageBucket: "easytel-259d3.appspot.com",
  messagingSenderId: "680065870132",
  appId: "1:680065870132:web:462893fc54bf9f2afd1d61",
  measurementId: "G-ZYDK9XNDYK"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Optional: Only get analytics if supported (to avoid SSR errors)
if (typeof window !== "undefined") {
  isAnalyticsSupported().then((supported) => {
    if (supported) getAnalytics(app);
  });
}

// Export Auth instance
const auth = getAuth(app);

export { auth };
